export const CONTENTFUL_ENTRY_IDS = {
  // Support pages
  SUPPORT_EMPLOYEE: 'orxrpKJacQk6pdVJ9fADA', // Vanliga frågor och svar (support-anstaelld)
  SUPPORT_ADMIN: '27f7NwUEAIhN2vvNF1Xrgm', // Hur kan vi hjälpa dig? (support-admin)

  // Home pages
  HOME_EMPLOYEE: 'G6Cr6pemRjt6BBcQypDQ1', // Home (Anställd)

  // Home banners
  HOME_BANNER_SCREENING: '7s3RkHs2YxV61gDavGwJku', // Börja med din screening
  HOME_BANNER_HEALTH_PLAN_PENDING: '7BbpNGcv6tPTb1PT2Gjmth', // Din hälsoplan är på väg NEW
  HOME_BANNER_HEALTH_PLAN_READY: '5ZSNxVyDnV0jZNMhqkkjmM', // Din hälsoplan är klar
  HOME_BANNER_CHECK_IN: '3wF6ToMkABUVFB6rWOYWXo', // Dags för en snabb check-in NEW
  HOME_BANNER_CONTINUE_HEALTH_PLAN: '3LRsRCrdmH9r3BXRToLmMe', // Fortsätt med din hälsoplan NEW
  HOME_BANNER_FOLLOW_UP: '517iycvZVnnxruIas7X6XF', // Dags att följa upp ditt mående
  HOME_BANNER_FOLLOW_UP_PENDING: 'jRbjA0rArra7dsnKuAnpq', // Din hälsoplan uppdateras NEW
  HOME_BANNER_TRAINING: '3xnlORuxTJVygc6r6x4ffZ', // Training (male users)
  HOME_BANNER_MANAGER_TRAINING: 'mFYoxLn4xdc7pf5n119JZ', // Manager training (male managers)

  // Archive/Knowledge bank
  ARCHIVE: '3ap5ziQNnKlrYanGJcpoIb', // Våra artiklar och poddavsnitt

  // Health services
  HEALTH_SERVICES: '7fBJr0isIM0vb7h0ffdwtj', // Hälsotjänster
  HEALTH_CALL: '33JHbfg7KIPcR4ozjOQvIl', // Hälsosamtal
  DIGITAL_HEALTH_CALL: '1zYZ4Y8ieQN0zAwZIbhHie', // Digitalt hälsosamtal
  ABOUT_DIGITAL_HEALTH_CALL: '3Y6FpHqTfr0ZkiXZjr0VJs', // Om digitala hälsosamtal
  HEALTH_CALL_FAQ: 'iPVrUMtuLqZ9SJ1NR6n9L', // Hur många hälsosamtal ingår i tjänsten?

  // Screening services
  SCREENING: '2lz5P5O5MIIRH5jBT8YTuB', // Digital screening för kvinnohälsa
  SCREENING_SERVICE: '0e3hHlfqKGppczI1NZa4f', // Screeningtjänst för kvinnohälsa
  ABOUT_SCREENING: 'UjzCHnjE7AFVEmRxZxdGJ', // Om screening för kvinnohälsa

  // Policies and security
  POLICY: '1Hc3VgfNpM40nnxX0fgoom', // Policy för kvinnohälsa
  DATA_SECURITY: '6qiBuofrWNuevsgl2ydcXX', // Om datasäkerhet
  PATIENT_DATA_SECURITY: '2TE9Sh4IlECoqWL14iy4LP', // Patient- & datasäkerhet

  // About pages
  ABOUT_ESTERCARE_EMPLOYEE: '7uLVVLTZ6ySW6aUqzLCTIt', // Om EsterCare (employee)
  ABOUT_ESTERCARE_ADMIN: '3WGbEmMiZOs87x8LUBkoYM', // Om EsterCare (admin)

  // Billing
  BILLING: '2QZhupi8nEl43PE94qlmx4', // Fakturering

  // Video content
  SWEDISH_ONLY_WEBINAR: '3tlKoEqFqMgjzztOPTeadu', // Webinar only available in Swedish
} as const

export type ContentfulEntryId = (typeof CONTENTFUL_ENTRY_IDS)[keyof typeof CONTENTFUL_ENTRY_IDS]
